var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"text":"","color":_vm.color}},[(_vm.icon)?_c('v-icon',{staticClass:"mr-1",attrs:{"color":_vm.color,"dense":"","small":""}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e(),_c('span',{staticClass:"overline"},[_vm._v(" "+_vm._s(_vm.selectModel(_vm.modelValue, _vm.dataSelectorKey))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }